// extracted by mini-css-extract-plugin
module.exports = {"Title":"unpublished-news-preview-list_Title__M0QJA"};